@if (callState() !== 'idle') {
  <div class="voip"
       [class.voip--ringing]="callState() === 'ringing'"
       [class.voip--connected]="callState() === 'connected'"
       [class.voip--ended]="callState() === 'ended'">

    @if (callState() === 'ringing' || callState() === 'connected') {
      <div class="voip__card">

        <!-- Stream de vídeo -->
        <div class="voip__video">
          <div #videoContainer class="voip__video-player"></div>
          @if (!videoUrl()) {
            <div class="voip__video-placeholder">
              <img src="assets/icons/header/headset.svg" alt="intercom">
            </div>
          }
          <span class="voip__video-label">
            @if (callState() === 'ringing') {
              Llamada entrante
            } @else {
              <span class="voip__dot"></span> En llamada
            }
          </span>
        </div>

        <!-- Info del llamante -->
        <div class="voip__info">
          @if (incomingCall(); as call) {
            <span class="voip__name">{{ call.displayname || call.caller }}</span>
            <span class="voip__sub">{{ call.callee }}</span>
          }
          @if (callState() === 'connected') {
            <span class="voip__status">{{ statusMessage() }}</span>
          }
        </div>

        <!-- Botones -->
        <div class="voip__actions">
          @if (callState() === 'ringing') {
            <button class="voip__btn voip__btn--answer" (click)="voip.answerCall()" title="Contestar">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
            </button>
            <button class="voip__btn voip__btn--reject" (click)="voip.hangup()" title="Rechazar">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
            </button>
          } @else {
            <button class="voip__btn voip__btn--reject" (click)="voip.hangup()" title="Colgar">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
            </button>
          }
        </div>

      </div>
    }

    @if (callState() === 'ended') {
      <div class="voip__toast">
        <span>Llamada finalizada</span>
      </div>
    }

  </div>
}

<audio #remoteAudio autoplay style="display:none"></audio>
<audio #ringtone src="assets/media/audio/ringtone.mp3" loop preload="auto" style="display:none"></audio>
